/**
 * Compression d'image côté navigateur avant envoi (réseau 3G) :
 * côté le plus long ≤ 1600 px, JPEG qualité 0,8. Les PDF et autres fichiers passent tels quels.
 */
export async function compresserImage(fichier: File, maxCote = 1600, qualite = 0.8): Promise<{ blob: Blob; nom: string }> {
  if (!fichier.type.startsWith('image/') || fichier.type === 'image/gif' || fichier.size < 250 * 1024) {
    return { blob: fichier, nom: fichier.name };
  }
  try {
    const bitmap = await chargerImage(fichier);
    const ratio = Math.min(1, maxCote / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * ratio), h = Math.round(bitmap.height * ratio);
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) return { blob: fichier, nom: fichier.name };
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(bitmap as any, 0, 0, w, h);
    const blob: Blob | null = await new Promise(res => canvas.toBlob(b => res(b), 'image/jpeg', qualite));
    if (!blob || blob.size >= fichier.size) return { blob: fichier, nom: fichier.name };
    return { blob, nom: fichier.name.replace(/\.[^.]+$/, '') + '.jpg' };
  } catch {
    return { blob: fichier, nom: fichier.name };   // format non décodable (HEIC sur certains navigateurs) : envoyé tel quel
  }
}

function chargerImage(f: File): Promise<HTMLImageElement | ImageBitmap> {
  if ('createImageBitmap' in window) {
    return (window as any).createImageBitmap(f, { imageOrientation: 'from-image' }).catch(() => imageElement(f));
  }
  return imageElement(f);
}

function imageElement(f: File): Promise<HTMLImageElement> {
  return new Promise((res, rej) => {
    const url = URL.createObjectURL(f);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); res(img); };
    img.onerror = e => { URL.revokeObjectURL(url); rej(e); };
    img.src = url;
  });
}
